import { render, staticRenderFns } from "./ServicesAdd.vue?vue&type=template&id=261cc358&"
import script from "./ServicesAdd.vue?vue&type=script&lang=js&"
export * from "./ServicesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports